/**
 * 创建人：D
 * 创建时间：2019-07-12
 * 描述：获取系统配置文件
 * 更新记录: 
 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from '../sw-http-client.service';
import { Subject } from 'rxjs';

@Injectable()
export class ConfigurationService {

  constructor(
    private http:SwHttpClientService //请求参数说明
    ) { }

  //系统配置
  configpdated: Subject<any> = new Subject<any>();
  config:any; 

  //初始化配置文件
  inItConfig() {
    let params = {
      "param": {},
      "entity": { parentId: "542f075fc828fecdb09f961a55f1efec", type: 2 }
    }
    this.http.Post(environment.seekerWebAPI+ 'applicationConfig/queryPageList', params).subscribe(data=>{
        this.configpdated.next(data.data.records) //发布配置数据
        this.config = data.data.records
    })
  }
}
